module.exports = __webpack_public_path__ + "static/img/gaozhonglishi10.ab0d9862.jpg";